<ion-content class="modal-content">
  <div class="modal-container w-full">
    <h3 class="title">{{ "clone-ticket-modal.title" | translate }}</h3>
    <p class="message">{{ "clone-ticket-modal.description" | translate }}</p>
    <p class="label">{{ "clone-ticket-modal.detail-label" | translate }}</p>

    <div class="detail-container">
      <div class="ticket-detail-row">
        <span class="label-detail">{{
          "clone-ticket-modal.reference-label" | translate
        }}</span>
        <span class="value-detail">{{ ticket.reference }}</span>
      </div>
      <div class="ticket-detail-row">
        <span class="label-detail">{{
          "clone-ticket-modal.quantity-label" | translate
        }}</span>
        <span class="value-detail">{{ ticket.quota || 0 }}</span>
      </div>
      <div class="ticket-detail-row">
        <span class="label-detail">{{
          "clone-ticket-modal.paid-status" | translate
        }}</span>
        <span class="value-detail">{{
          ticket.payment_status
            ? ("clone-ticket-modal.paid-badge" | translate)
            : ("clone-ticket-modal.unpaid-badge" | translate)
        }}</span>
      </div>
    </div>
    <div class="button-container">
      <ion-button
        expand="block"
        class="btn-cancel"
        color="medium"
        (click)="closeModal()"
        >{{ "clone-ticket-modal.cancel" | translate }}</ion-button
      >
      <ion-button
        expand="block"
        class="btn-config btn-expand"
        (click)="cloneTicket()"
        [disabled]="isCloning"
      >
        {{
          isCloning
            ? ("clone-ticket-modal.loading" | translate)
            : ("clone-ticket-modal.clone" | translate)
        }}
      </ion-button>
    </div>
  </div>
</ion-content>
